import { Box, Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../GenericFieldComponents/common/DiffModal.js';
import { IRecommendation } from '@publishing-engine/domain/models/submission';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import FileViewerButtonText from '../FileViewerButtonText.js';

interface Props {
  Recommendation: IRecommendation;
  onClose: () => void;
  submissionContextId?: string;
}

const zeroState = (
  <Flex
    flexDirection="row"
    justifyContent="space-between"
    backgroundColor="surfaceTertiaryFill"
    padding={4}
    color="neutralSecondaryContent"
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <Text textStyle="textBody">No Recommendation Comment provided</Text>
    </Flex>
  </Flex>
);

export const CommentDiffModal = ({
  onClose,
  Recommendation,
  submissionContextId
}: Props) => {
  const {
    commentForAuthor = '',
    attachments = [],
    moderatedCommentForAuthor,
    moderatedAttachments = []
  } = Recommendation ?? {};

  const showModeratedAttachments = (moderatedAttachments ?? []).filter(
    file => file?.visibility === 'show'
  );
  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={'Feedback for Authors'}>
        <button></button>
        {Recommendation ? (
          <Box>
            <Box>
              <Text textStyle="textBody">{commentForAuthor}</Text>
            </Box>
            {!!attachments?.length && (
              <Box marginTop={4}>
                <Text textStyle="headingItem">
                  Attached files ({attachments?.length})
                </Text>
                <Flex flexDirection="column" marginTop={2} gap={2}>
                  {(attachments ?? []).map(attachment => (
                    <>
                      <Flex
                        justifyContent="space-between"
                        key={attachment?.referenceName}
                        padding={2}
                        borderTop={'1px'}
                        borderColor="neutralPrimaryBorder"
                      >
                        <Flex gap={2} alignItems="center">
                          <FontAwesomeIcon icon={faFile} />
                          <Text textStyle="textBody">
                            {attachment?.referenceName}
                          </Text>
                          <FileViewerButtonText
                            file={attachment}
                            submissionContextId={submissionContextId}
                          >
                            View
                          </FileViewerButtonText>
                        </Flex>
                      </Flex>
                    </>
                  ))}
                </Flex>
              </Box>
            )}
          </Box>
        ) : (
          zeroState
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={'Feedback for Authors'}>
        <button></button>{' '}
        {moderatedCommentForAuthor ? (
          <Box>
            <Box>
              <Text textStyle="textBody"> {moderatedCommentForAuthor}</Text>
            </Box>
            {!!showModeratedAttachments?.length && (
              <Box marginTop={4}>
                <Text textStyle="headingItem">
                  Attached files ({showModeratedAttachments?.length})
                </Text>
                <Flex flexDirection="column" marginTop={2} gap={2}>
                  {(showModeratedAttachments ?? []).map(attachment => (
                    <>
                      <Flex
                        justifyContent="space-between"
                        key={attachment?.referenceName}
                        padding={2}
                        borderTop={'1px'}
                        borderColor="neutralPrimaryBorder"
                      >
                        <Flex gap={2} alignItems="center">
                          <FontAwesomeIcon icon={faFile} />
                          <Text textStyle="textBody">
                            {attachment?.referenceName}
                          </Text>
                          <FileViewerButtonText
                            file={attachment}
                            submissionContextId={submissionContextId}
                          >
                            View
                          </FileViewerButtonText>
                        </Flex>
                      </Flex>
                    </>
                  ))}
                </Flex>
              </Box>
            )}
          </Box>
        ) : (
          zeroState
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
